import {cmsActionDeletable} from '@netx/core-cms/enablers';

export default [
	/** @action */
	{
		event: 'cms:action:new',
		label: i18n.t('i18n.addAction'),
		wrapper(view, e) {
			if (
				view.model.constructor.__name__ === 'CMSPortal' ||
				view.model.constructor.__name__ === 'SystemPortal'
			) {
				return [view.model.id];
			} else if (view.model.has('portalId')) {
				return [view.model.get('portalId')];
			} else {
				throw new Error("Can't find portalId in wrapper");
			}
		},
	},
	/** @action */
	{
		event: 'cms:action:edit',
		label: i18n.t('i18n.editAction'),
		wrapper(view, e) {
			return [view.model];
		},
	},
	/** @action */
	{
		event: 'cms:action:delete',
		label: i18n.t('i18n.deleteAction'),
		enableTest: cmsActionDeletable,
		wrapper(view, e) {
			return [view.model];
		},
	},
	/** @action */
	{
		event: 'cms:page:faq:route',
		label: 'FAQs',
		route: 'page/faq',
	},
	/** @action */
	{
		event: 'cms:page:fantastic:route',
		label: 'fantastic',
		route: 'page/sub1/fantastic',
	},
	/** @action */
	{
		event: 'cms:route:category:root',
		label: i18n.t('i18n.assets'),
	},
	/** @action */
	{
		event: 'cms:page:template:edit',
		label: i18n.t('i18n.chooseTemplate'),
		userLevel: 8,
		wrapper(view) {
			return [view.model];
		},
	},
	/** @action */
	{
		event: 'cms:page:new',
		label: i18n.t('i18n.addPage'),
		userLevel: 8,
		wrapper(view) {
			// assume we came here from a portal view so view.model is a Portal
			return [view.model]; // argument is the portal modal.
		},
	},
	/** @action */
	{
		event: 'cms:page:edit',
		label: i18n.t('i18n.editPage'),
		userLevel: 8,
		wrapper(v, e) {
			return [v.model, v, e];
		},
	},
	/** @action */
	{
		event: 'cms:page:delete',
		label: i18n.t('i18n.deletePage'),
		userLevel: 8,
		wrapper(v, e) {
			return [v.model, v, e];
		},
	},
	/** @action */
	{
		event: 'cms:page:title:edit',
		label: i18n.t('i18n.renameTitle'),
		userLevel: 8,
		wrapper(v, e) {
			return [v.model.get('portalId'), v.model, v, e];
		},
	},
	/** @action */
	{
		event: 'cms:page:block:add',
		label: i18n.t('i18n.addBlock'),
		userLevel: 8,
		wrapper(v, e) {
			return [v.model, e];
		},
	},
	/** @action */
	{
		event: 'cms:page:block:delete',
		label: i18n.t('i18n.deleteBlock'),
		userLevel: 8,
		wrapper(v, e) {
			return [v.model];
		},
	},
];
